import { render } from "./SearchWidgetCustomElement.vue?vue&type=template&id=51ccd7b0&scoped=true"
import script from "./SearchWidgetCustomElement.vue?vue&type=script&lang=js"
export * from "./SearchWidgetCustomElement.vue?vue&type=script&lang=js"

import "./SearchWidgetCustomElement.vue?vue&type=style&index=0&id=51ccd7b0&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src354116273/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ccd7b0"]])

export default __exports__